/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type IncidentsCreateDto = {
  /**
   * Email subject
   */
  subject: IncidentsCreateDto.subject;
  /**
   * Email content
   */
  description: string;
};
export namespace IncidentsCreateDto {
  /**
   * Email subject
   */
  export enum subject {
    DEVICE_ISSUE = 'DEVICE_ISSUE',
    MOBILE_APP_ISSUE = 'MOBILE_APP_ISSUE',
    PORTAL_ISSUE = 'PORTAL_ISSUE',
    OTHER = 'OTHER',
  }
}

